import api from "./api";

export function getBankAccountPage(country_id) {
  return api.get(`/bankaccountpage/${country_id}`);
}

export function createBankAccountPage(data) {
  return api.post("/bankaccountpage", data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function updateBankAccountPage(country_id, data) {
  return api.put(`/bankaccountpage/${country_id}`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
